import React from 'react';
import styled from 'styled-components';

const VideoContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
  background: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 8px;
`;

const VideoPanel = () => {
  return (
    <VideoContainer>
      <h3>Video Panel</h3>
      <p>This is the video panel component.</p>
    </VideoContainer>
  );
};

export default VideoPanel;
